
namespace GeniuzPOS.Customer {

    @Serenity.Decorators.registerClass()
    export class CsCustGroupDialog extends Serenity.EntityDialog<CsCustGroupRow, any> {
        protected getFormKey() { return CsCustGroupForm.formKey; }
        protected getIdProperty() { return CsCustGroupRow.idProperty; }
        protected getLocalTextPrefix() { return CsCustGroupRow.localTextPrefix; }
        protected getNameProperty() { return CsCustGroupRow.nameProperty; }
        protected getService() { return CsCustGroupService.baseUrl; }
        protected getDeletePermission() { return CsCustGroupRow.deletePermission; }
        protected getInsertPermission() { return CsCustGroupRow.insertPermission; }
        protected getUpdatePermission() { return CsCustGroupRow.updatePermission; }

        protected form = new CsCustGroupForm(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Idd = Q.tryFirst(CsCustomerRow.getLookup().items, x => x.CustGroupCode == this.entity.CustGroupCode);
            if (Idd != null) {
                this.deleteButton.toggleClass('disabled', true);
            }

        }
    }
}